@if (project) {
  <div class="view-section" id="location">
    <h3 class="view-section-header">Geographic Location</h3>
    <div class="details">
      <div class="row">
        @if (!isStrategy && !isWholeSystem && !isProgramManagement) {
          <div class="col-md-12"
            >
            <h5 class="text-success">Map</h5>
            <div id="MapViewContainer">
              @if (project.latitude && project.longitude) {
                <app-map-container [project]="project"
                [mapType]="'detail'"></app-map-container>
              }
            </div>
            @if (project.address) {
              <div class="p-2">
                <p><span class="font-weight-bold">Geolocation</span> {{ project.address }}</p>
              </div>
            }
          </div>
        }
      </div>
      <div class="row">
        @if (project.countries.length) {
          <div class="col-md-6">
            <h6 class="text-success mt-2">Country</h6>
            @for (country of project.countries; track country) {
              <span>
                <span class="badge badge-info font-size-lg mr-1 mb-1">
                {{ country.geography.name }}</span>
              </span>
            }
            @if (project.countries.length === 0) {
              <span class="text-warning">No country specified.</span>
            }
          </div>
        }
        @if (project.states.length) {
          <div class="col-md-6">
            <h6 class="text-success mt-2">State/Province</h6>
            @for (state of project.states; track state) {
              <span>
                <span class="badge badge-info font-size-lg mr-1 mb-1">
                {{ state.geography.name }}</span>
              </span>
            }
            @if (project.states.length === 0) {
              <span class="text-warning">No state/province specified.</span>
            }
          </div>
        }
      </div>
      @if (!isStrategy && !isWholeSystem && !isProgramManagement) {
        <div class="row">
          <div class="col-md-12">
            <h6 class="text-success mt-2">Spatial Extent</h6>
            @if (project.projectSpatialExtents.length) {
              <span>
                @for (extent of project.projectSpatialExtents; track extent) {
                  <span>
                    <span
                      class="badge badge-flat border-info text-info-600 font-size-lg mr-1 mb-1">{{extent.spatialExtent.spatialExtentGroup.name}}:
                    {{ extent.spatialExtent.name }}</span>
                  </span>
                }
              </span>
            }
            @if (!project.projectSpatialExtents.length) {
              <span class="text-warning">No spatial extent specified.</span>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
